// src/pages/BlockParentDashboard.tsx
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";


import MomPage from "../MomPage";
import BlockDashboard1 from "./BlockDashboard1";
import BlockDashboard2 from "./BlockDashboard2";
import BlockDashboard3 from "./BlockDashboard3";

interface ParentProps {
  finYear: string;
  meetingType: any;
}

const BlockParentDashboard: React.FC<ParentProps> = ({ finYear, meetingType }) => {
  const blockData = useSelector(
    (state: RootState) => state.common.dashboardData["Block Panchayats"]
  );

  const isStateSelected =
    blockData?.state_code !== null && blockData?.state_name !== "";
  const isZpSelected =
    blockData?.zp_lgd_code !== null && blockData?.zp_name !== "";
  const isBpSelected =
    blockData?.bp_lgd_code !== null && blockData?.bp_name !== "";

  return (
    <>
      {!isStateSelected ? (
        <BlockDashboard1 finYear={finYear} meetingType={meetingType} />
      ) : !isZpSelected ? (
        <BlockDashboard2 finYear={finYear} meetingType={meetingType} />
      ) : !isBpSelected ? (
        <BlockDashboard3 finYear={finYear} meetingType={meetingType} />
      ) : (
        <MomPage finYear={finYear} meetingType={meetingType} />
      )}
    </>
  );
};

export default BlockParentDashboard;
